/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./PayMeLink.css";
import PropTypes from "prop-types";
import { simpleFetch } from "../../restWrapper";

class PayMeLink extends Component {
  constructor(props) {
    super(props);
    try {
      if (this.props.location.state.amount) {
        this.state = {
          ...this.props.location.state,
          loading: false,
        };
      }
    } catch (e) {
      this.props.history.push({
        pathname: "/SelectMission",
      });
    }

    this.onNextBtn = this.onNextBtn.bind(this);
  }

  componentDidMount() {
    this.pageTimeout = setTimeout(() => {
      this.setState({
        status: "expired",
      });
      const dataObj = this.state;
      this.props.history.push({
        pathname: "/ErrorPromptPayMe",
        state: dataObj,
      });
    }, 600000);
  }

  onNextBtn() {
    clearTimeout(this.pageTimeout);
    this.setState({
      loading: true,
    });

    // Determine the endpoint based on authentication status
    // Check isAuth or userAuthenticated flags passed from PersonalDetails/SelectPayment
    const isAuthenticated = this.state.isAuth || this.state.userAuthenticated;
    const paymeEndpoint = isAuthenticated
      ? "/donors/payments/paymeLink"
      : "/user/payments/paymeLink";

    simpleFetch(paymeEndpoint, "POST", {
      amount: this.state.amount,
      projectId: this.state.projectId,
      firstName:
        this.state.donorInfo.firstName === "" &&
        this.state.donorInfo.lastName === ""
          ? "Not Provided"
          : this.state.donorInfo.firstName,
      lastName:
        this.state.donorInfo.firstName === "" &&
        this.state.donorInfo.lastName === ""
          ? ""
          : this.state.donorInfo.lastName,
      email: this.state.donorInfo.email,
      phoneNumber: this.state.donorInfo.phoneNumber,
      currency: "hkd",
      memo: this.state.donorInfo.memo || "",
      country: this.state.country || "HK",
      transactionType: this.state.transactionType || 'donation',

      /* Fee-related data */
      coverFee: this.state.coverFee || false,
      baseAmount: this.state.amount,
      feeBreakdown: this.state.feeBreakdown || null,

      /* PayMe specific data */
      clientId: this.state.organization.clientId,
      clientSecret: this.state.organization.clientSecret,
      signingKeyId: this.state.organization.signingKeyId,
      signingKey: this.state.organization.signingKey,
    }).then((res) => {
      if (res.status !== 200) {
        this.setState({
          status: "error",
        });
        const dataObj = this.state;
        this.props.history.push({
          pathname: "/ErrorPromptPayMe",
          state: dataObj,
        });
      } else {
        this.setState({
          loading: false,
        });
        const result = res.body.result;

        let dataObj = this.props.location.state;
        dataObj.PayMePaymentRequestId = result.paymentRequestId;

        if (result) {
          const { webLink: qrUrl } = result;
          localStorage.setItem("state", JSON.stringify(dataObj));
          window.location.assign(qrUrl);
        }
      }
    });
  }

  render() {
    if (
      this.state.loading ||
      this.props.location.state === null ||
      this.props.location.state === undefined
    ) {
      return <this.props.RenderFullPageLoading />;
    }
    const languageObj = this.props.languageObj;

    return (
      <div className="PayMeLink-view">
        <div className="PayMeLink-prompt">
          <div
            className="PayMeLink-back"
            onClick={() => {
              clearTimeout(this.pageTimeout);
              let dataObj = this.state;
              this.props.history.push({
                pathname: "/Review",
                state: dataObj,
              });
            }}
          >
            <div className="PayMeLink-backBtn"></div>
            <div className="PayMeLink-backText">{languageObj.backText}</div>
          </div>

          <div className="PayMeLink-phone"></div>
          <div className="PayMeLink-text">{languageObj.payme}</div>

          <div className="PayMeLink-btn" onClick={this.onNextBtn}></div>
        </div>
      </div>
    );
  }
}

PayMeLink.propTypes = {
  languageObj: PropTypes.object,
};

export default PayMeLink;
